import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";

import { PrismaWordmark } from "../components/brand/PrismaWordmark";
import { Avatar } from "../components/Avatar";
import { useSession } from "../lib/session";
import { NAVIGATION } from "./navigation";

export function Sidebar() {
  const { t } = useTranslation();
  const me = useSession();
  const role = me.roles[0];
  return (
    <aside
      className="flex h-full w-[var(--sidebar-width)] shrink-0 flex-col border-r border-line bg-surface"
      aria-label={t("nav.label")}
    >
      <div className="px-6 pb-5 pt-6">
        <PrismaWordmark className="h-7 w-auto text-ink" role="img" aria-label={t("common.app_name")} />
        <div className="mt-1.5 pl-9 text-[13px] text-ink-2">{t("common.creative_zone")}</div>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 [scrollbar-width:thin]" aria-label={t("nav.label")}>
        {NAVIGATION.map((group, gi) => (
          <div key={group.labelKey ?? "main"} className={gi > 0 ? "mt-3 border-t border-line pt-3" : ""}>
            {group.labelKey && (
              <div className="px-3 pb-1.5 text-[12px] font-medium text-ink-2">{t(group.labelKey)}</div>
            )}
            <ul className="space-y-0.5">
              {group.items.map((item) => (
                <li key={item.key}>
                  <NavLink
                    to={item.path}
                    end={item.path === "/"}
                    className={({ isActive }) =>
                      [
                        "group flex h-[38px] items-center gap-3 rounded-[var(--radius-control)] px-3 text-[14px] transition-colors",
                        isActive
                          ? "bg-[var(--nav-active-bg)] font-semibold text-ink shadow-[inset_3px_0_0_var(--accent-primary)]"
                          : "text-ink-2 hover:bg-elevated hover:text-ink",
                      ].join(" ")
                    }
                  >
                    <item.icon aria-hidden="true" className="size-[18px] shrink-0" strokeWidth={1.75} />
                    <span className="truncate">{t(`nav.${item.key}`)}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
      <div className="border-t border-line px-4 py-3">
        <NavLink
          to="/settings"
          className="flex items-center gap-3 rounded-[var(--radius-control)] p-2 hover:bg-elevated"
        >
          <Avatar name={me.name} />
          <span className="min-w-0 flex-1">
            <span className="block truncate text-[14px] font-medium text-ink">{me.name}</span>
            <span className="block truncate text-[12px] text-ink-2">{role ? t(`role.${role}`) : null}</span>
          </span>
          <ChevronRight aria-hidden="true" className="size-4 text-ink-3" />
        </NavLink>
        <div className="mt-3 px-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-violet-text">
          {t("nav.tagline")}
        </div>
      </div>
    </aside>
  );
}
